import { requireOrgPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { usePermission, useUserState } from '@juvare/contact-management/ui/hooks';
export function useAuthorizeManageMission() {
    const { requireAnySystemPermission } = usePermission();
    const userState = useUserState();
    const authorizeManageMission = (missionTypeId, missionOrganizationSharing) => {
        if (requireAnySystemPermission('manage-missions')) {
            return true;
        }
        const activeOrganizationIds = Object.keys(userState.orgRole);
        const allowManageMissionType = userState.authorizedMissionTypeIds.includes(missionTypeId);
        const allowManageOrganization = missionOrganizationSharing.some((id) => activeOrganizationIds.includes(id) && requireOrgPermission(userState, id, 'manage-organization'));
        return allowManageMissionType && allowManageOrganization;
    };
    return { authorizeManageMission };
}
